import { isValidPhoneNumber } from 'libphonenumber-js'
import { z } from 'zod'

import { emailField } from '@/lib/email/schema'

const trialFormEstablishmentSchema = z.object({
  siret: z.string(),
  name: z.string(),
  apeCode: z.string(),
  isUai: z.boolean(),
  isFiness: z.boolean(),
})

export const trialFormCompanySchema = z.object({
  siren: z.string(),
  siret: z.string(),
  name: z.string(),
  apeCode: z.string(),
  address: z.string(),
  establishmentsCount: z.number().int().nonnegative(),
  openEstablishmentsCount: z.number().int().nonnegative(),
  isUai: z.boolean(),
  isFiness: z.boolean(),
  establishments: z.array(trialFormEstablishmentSchema),
})

export const trialFormSchema = z.object({
  firstName: z.string().trim().min(1, 'firstNameRequired'),
  lastName: z.string().trim().min(1, 'lastNameRequired'),
  email: emailField,
  // Optional — prefilled into HubSpot only when the visitor provides it.
  phone: z
    .string()
    .optional()
    .refine((value) => !value || isValidPhoneNumber(value), {
      message: 'invalidPhone',
    }),
  // The explicit `: boolean` return type is required — without it, TypeScript
  // auto-infers this as a type predicate (`v is TrialFormCompany`), which zod's
  // conditional refine() overload picks up and uses to narrow this field's
  // output type to non-null, breaking `selectedCompany: null` everywhere it's
  // used (defaultValues, form.setValue). Do not remove the annotation.
  selectedCompany: trialFormCompanySchema
    .nullable()
    .refine((v): boolean => v !== null, {
      message: 'selectRequired',
    }),
  website: z.string().optional().default(''),
})

export type TrialFormCompany = z.infer<typeof trialFormCompanySchema>
export type TrialFormValues = z.infer<typeof trialFormSchema>
